import React from 'react';

export const pageMeta = {
  "name": "JS Math",
  "link": "/javascript/math"
};

export default function JavascriptMath() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JS Math</h2>
      <p>Route: /javascript/math</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
